// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../login/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../login/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input:-webkit-autofill~label[data-v-6600db58],input:focus-visible~label.animate-label-on-focus[data-v-6600db58]{transform:translateY(-.9285714286rem) scale(.75)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
